import React, {useEffect} from "react";
import CommonLoginForm from "./CommonLoginForm";

function CollaboratorLogin() {
  // useEffect to load the google reCaptcha script once component is fully rendered
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [])
  return (
    <div>
      <CommonLoginForm type="collaborator" />
    </div>
  );
}

export default CollaboratorLogin;
